import { useRenderedBootHumanWait } from '#~/routes/boot-overlay/boot-budget-view.js';
import { getCurrentVendor, Vendor } from '@studio/design-system/themes/vendor.js';
import { type ReactElement } from 'react';
import * as HiveSetup from './vendor/hive/setup.js';
import * as IrisSetup from './vendor/iris/setup.js';

/** Alias. */
export { Setup as Root };

/**
 * `<Setup>` component.
 *
 * BootOverlay dismissal for this route (and every non-index boot-protected
 * route) is owned by `<BootReadyLayout>` in router.tsx, which publishes
 * `boot.isRootReady` on mount. This route no longer publishes it itself (ENG-4186).
 */
export const Setup = (): ReactElement => {
  useRenderedBootHumanWait(true);

  const vendor = getCurrentVendor();

  if (vendor === Vendor.IRIS) {
    return <IrisSetup.Setup />;
  }

  return <HiveSetup.Setup />;
};
